var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-box",style:({
    width: `${typeof _vm.width === 'number' ? `${_vm.width}px` : _vm.width}`,
    height: `${typeof _vm.height === 'number' ? `${_vm.height}px` : _vm.height}`,
    backgroundColor: _vm.bgColor,
    backgroundImage: `url(${_vm.imgSrc})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50%',
    backgroundSize: 'contain',
    borderRadius: `${_vm.borderRadius}px`
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }